<template>
  <b-modal
    lazy
    size="xl"
    class="v3_modal"
    :ok-only="true"
    ok-title="Close"
    ok-variant="v3_teal_outline"
    :visible="!!jobOfferId"
    footer-class="border_0 justify-content-end"
    @ok="$emit('close')"
    @hidden="$emit('close')"
  >
    <template slot="modal-header-close">
      <span>Close window</span>
      <i class="mdi mdi-close-circle-outline" />
    </template>

    <div class="v3_color_teal text-center mb-4 font-weight-bold font_size_1125rem">
      Job Opportunity Matches [{{ total }}]
    </div>

    <DataTable
      ref="dataTable"
      :show-filters="false"
      :show-pager="true"
      :get-items="getJobProfiles"
      :fields="fields"
      :empty-html="emptyText"
      :admin-table="false"
      :border-less="true"
    >
      <!-- templates for custom columns -->
      <template slot="specialty" slot-scope="data">
        {{ data.item.specialty }} / {{ data.item.subspecialty }}
      </template>
      <template slot="location" slot-scope="data">
        {{ parseItemLocation(data.item) }}
      </template>
      <template slot="compensation" slot-scope="data">
        {{ data.item.compensation | formatComaDot }}
      </template>
      <template slot="min_practice" slot-scope="data">
        {{ data.item.min_practice  }}
      </template>
      <template slot="status" slot-scope="data">
        {{ data.item.status  }}
      </template>
    </DataTable>
  </b-modal>
</template>

<script>
import Api from '@/providers/Api';
import DataTable from '@/components/DataTable';
import FormatNumberFilterMixin from '@/mixins/FormatNumberFilterMixin';

export default {
  name: 'RecruiterJobOffersMatchesModal',
  mixins: [FormatNumberFilterMixin],
  components: {
    DataTable,
  },
  model: {
    prop: 'jobOfferId',
    event: 'change',
  },
  props: {
    jobOfferId: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
      fields: [
        { key: 'candidate_id', sortable: false, label: 'Candidate ID' },
        {
          key: 'specialty',
          sortable: false,
          label: 'Specialty / Sub-Specialty',
          custom: true,
        },
        {
          key: 'location',
          sortable: false,
          label: 'Location',
          custom: true,
        },
        {
          key: 'compensation',
          sortable: false,
          label: 'Min Compensation',
          custom: true,
        },
        {
          key: 'min_practice',
          sortable: false,
          label: 'Practice',
          custom: true,
        },
        {
          key: 'status',
          sortable: false,
          label: 'Status',
          custom: true,
        },
      ],
      total: 0,
    };
  },
  computed: {
    emptyText: function () {
      return this.loading ? 'Loading data...' : undefined;
    },
  },
  methods: {
    getJobProfiles: async function (params) {
      this.loading = true;
      const data = await Api.getMatchingJobProfilesByJobOfferId(
        this.jobOfferId,
        params
      );
      params.totalRows = data.totalRows;
      this.total = data.totalRows;
      this.loading = false;
      return data.items;
    },
    parseItemLocation: function (item) {
      const j = (item.location) ? JSON.parse(item.location) : '';
      return (j.display_name) ? j.display_name : '-';
    },
  },
};
</script>

<style scoped />
